import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import styled, { css } from 'styled-components';

export const MultiSelectDropdown = styled(Select)`
  font-size: 14px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  border: 1px solid ${({ theme }) => theme.atlas.semantic.color.outline.default};
  background-color: ${({ theme }) =>
    theme.atlas.semantic.color.surface.default};
  border-radius: 5px;
  min-width: 450px;
  text-align: left;

  &:hover {
    background-color: ${({ theme }) =>
      theme.isVaultVariant
        ? theme.atlas.semantic.color.action.primary.default
        : theme.atlas.semantic.color.action.secondary.hoverFill};
    border: 1px solid
      ${({ theme }) =>
        theme.isVaultVariant
          ? theme.atlas.semantic.color.action.primary.default
          : theme.atlas.semantic.color.outline.hover};
    ${({ theme }) =>
      theme.isVaultVariant
        ? `color: ${theme.atlas.semantic.color.type.inverse}; opacity: 0.5;`
        : ''}
  }
  &:before {
    content: none;
  }
  margin: ${(props) => `${props.theme.spacing(1)}px`};
  & .MuiSelect-select {
    padding-right: 0px;
  }

  & .MuiSelect-select:focus {
    background-color: ${({ theme }) =>
      theme.atlas.semantic.color.surface.default};
    border-radius: 5px;
    padding-right: 0px;
  }

  & .MuiSelect-select:hover {
    background-color: ${({ theme }) =>
      theme.isVaultVariant
        ? theme.atlas.semantic.color.action.primary.default
        : theme.atlas.semantic.color.action.secondary.hoverFill};
    ${({ theme }) =>
      theme.isVaultVariant
        ? `color: ${theme.atlas.semantic.color.type.inverse};`
        : ''}
  }

  & .MuiInputBase-input {
    padding: 8px 16px;
  }
`;

export const MultiSelectMenuItem = styled(MenuItem)`
  font-size: 14px;
  &:hover {
    background-color: ${({ theme }) =>
      theme.isVaultVariant
        ? theme.atlas.semantic.color.action.primary.default
        : theme.atlas.semantic.color.action.secondary.hoverFill} !important;
    ${({ theme }) =>
      theme.isVaultVariant
        ? `color: ${theme.atlas.semantic.color.type.inverse}; opacity: 0.5;`
        : ''}
  }
  padding: ${(props) =>
    `${props.theme.spacing()}px ${props.theme.spacing() * 2}px`};
  min-width: 448px;
  text-align: center;
`;

const buttonHover = css`
  &:hover {
    cursor: pointer;
  }
`;

export const Expand = styled(ArrowDropDownIcon)`
  ${buttonHover}
`;

export const Close = styled(ArrowDropUpIcon)`
  ${buttonHover}
`;
